import React from 'react';
import { Upload, Icon, message } from 'antd';

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt1MB = file.size / 1024 / 1024 < 1;
  if (!isLt1MB) {
    message.error('Image must smaller than 1MB!');
  }
  return isJpgOrPng && isLt1MB;
}

class Avatar extends React.Component {
  state = {
    loading: false,
    imageUrl: this.props.srcImage
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.srcImage !== this.props.srcImage) {
      this.setState({ imageUrl: this.props.srcImage });
    }
  }

  handleChange = info => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    else { //if (info.file.status === 'done')
      if (!info.file.originFileObj)
        return;

      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl =>
        this.setState({
          imageUrl,
          loading: false,
        }, () => {
          this.props.setImage(info.file.originFileObj, imageUrl)
        }),
      );
    }
  };

  render() {
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">{this.props.uploadButtonText ? this.props.uploadButtonText : "Upload"}</div>
      </div>
    );

    const { imageUrl } = this.state;
    return (
      <Upload
        name="avatar"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        //action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        beforeUpload={beforeUpload}
        onChange={this.handleChange}
        headers={"t"}
        accept=".png,.jpg,.jpeg"
      >
        {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '500px' }} /> : uploadButton}
      </Upload>
    );
  }
}

export default Avatar;